/** Shared plain-English rendering for TimesheetReviewPeriod anomaly hits — used by both the
 *  OM review page and the Payroll page, so the wording an OM sees when resolving an anomaly
 *  matches exactly what HR sees later on the same day's payroll row. */

export interface AnomalyHit {
  ruleKey: string;
  workDate: string;
  detail: string;
}

const ANOMALY_RULE_LABELS: Record<string, string> = {
  daily_overtime_over_1hr: "More than 1 hour of overtime in a single day",
  shift_over_9_hours: "A single shift longer than 9 hours",
};

export function formatAnomalyDetail(hit: Pick<AnomalyHit, "ruleKey" | "detail">): string {
  const label = ANOMALY_RULE_LABELS[hit.ruleKey] ?? hit.ruleKey.replace(/_/g, " ");
  const detail = hit.detail
    .replace(/(\d+) min overtime/, "$1 minutes of overtime beyond the daily limit")
    .replace(/([\d.]+)h shift/, "$1 hour shift");
  return `${label} (${detail})`;
}
